export default [
  {
    path: '/imglist',
    name: 'ImgList',
    component: () => import('../views/img/imglist.vue'),
    meta:{
      title:'全部图片'
    }
  },
]
